import gql from 'graphql-tag';

export const readAllEvidenceQuery = gql`
  query ReadAllEvidence($search: String, $page: Int, $take: Int, $sortColumn: String, $sortDirection: String, $categories: [Int!]) {
    response: readAllEvidence(
      search: $search
      take: $take
      page: $page
      sortColumn: $sortColumn
      sortDirection: $sortDirection,
      categories: $categories
    ) {
      total
      page
      take
      hasMore
      items {
        id
        kategorie {
          id
          nazev
        }
        pole{
          data
          vstupni_pole{
            id
            nazev
          }
        }
      }
    }
  }
`;
